import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "rescind-box" }
const _hoisted_4 = { class: "lable" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "rescind-box" }
const _hoisted_7 = { class: "lable" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "image-list" }
const _hoisted_10 = { class: "btn-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "申请" + _toDisplayString(_ctx.recordTitle), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.recordTitle) + "原因：", 1),
        _cache[4] || (_cache[4] = _createElementVNode("span", null, null, -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.reason,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reason) = $event)),
          rows: 7,
          placeholder: `请输入${_ctx.recordTitle}原因`,
          type: "textarea"
        }, null, 8, ["modelValue", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, "上传" + _toDisplayString(_ctx.recordTitle) + "函：", 1),
        _cache[5] || (_cache[5] = _createElementVNode("span", null, "(加盖公司公章)", -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadRescindLetter()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("下载" + _toDisplayString(_ctx.recordTitle) + "函模板", 1)
          ]),
          _: 1
        }),
        (_ctx.attachments.length<4)
          ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 0,
              action: _ctx.uploadUrl,
              class: "upload-demo",
              "before-upload": _ctx.uploadFile,
              limit: 3,
              "show-file-list": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("上传图片")
                  ])),
                  _: 1,
                  __: [6]
                })
              ]),
              _: 1
            }, 8, ["action", "before-upload"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearImg()))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("清空图片")
          ])),
          _: 1,
          __: [7]
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (image) => {
        return (_openBlock(), _createBlock(_component_el_image, {
          key: image,
          src: image,
          fit: _ctx.fit,
          "preview-src-list": _ctx.attachments,
          "initial-index": 0
        }, null, 8, ["src", "fit", "preview-src-list"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.rescind()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定" + _toDisplayString(_ctx.recordTitle), 1)
        ]),
        _: 1
      })
    ])
  ]))
}